























import _ from 'lodash'
import { Component, Vue, Watch } from 'vue-property-decorator'

@Component
export default class AmoCRMSettings extends Vue {
  alias = 'amocrm'

  setting: any | null = null

  form = {
    data: null,
    defaults: {
      domain: null,
      login: null,
      hash: null
    },
    setting: {
      labelCol: { span: 5 },
      wrapperCol: { span: 19 }
    }
  }

  get link() {
    const data: any = this.form.data
    return `https://${data.domain}/?USER_LOGIN=${data.login}&USER_HASH=${data.hash}`
  }

  setFormData() {
    const config = this.setting ? _.cloneDeep(this.setting.config) : {}
    this.$set(this.form, 'data', _.defaultsDeep(config, this.form.defaults))
  }

  async getOrCreateConfig() {
    await this.getConfig()
    if (!this.setting) await this.createConfig()
  }

  async getConfig() {
    const params = { filter: [`alias||$eq||${this.alias}`] }
    const {
      data: [setting]
    } = await this.$api.get('/settings', { params })
    this.setting = setting
  }

  async createConfig() {
    const { data: setting } = await this.$api.post('/settings', { alias: this.alias })
    this.setting = setting
  }

  async updateConfig() {
    const { data: setting } = await this.$api.patch(`/settings/${this.setting!.id}`, { config: this.form.data })
    this.setting = setting
    await this.$message.success(`Сохранено`)
  }

  async created() {
    await this.getOrCreateConfig()
  }

  @Watch('setting', { immediate: true })
  onConfigChange() {
    this.setFormData()
  }
}
